/**
 * ファクトの引用文（原文からの抜き出し）を取り出す。
 *
 * 旧データは `evidence` キーで保存されているため、両方を見る。
 * 一括マイグレーションを避け、読み出し側で吸収する方針。
 */
export function getQuote(fact: { quote?: string; evidence?: string } | null | undefined): string {
  return fact?.quote ?? fact?.evidence ?? '';
}
